import { Directive, ElementRef, Input, OnChanges } from '@angular/core';

/**
 * Row-level counterpart of GridCellHookDirective: calls a DevExtreme-shaped
 * `onRowPrepared` handler for each rendered data row.
 *
 * Same reasoning as the cell hook - the existing handler reads
 * `event.rowType === 'data'`, `event.data` and `event.rowElement.style`, so
 * handing it that exact shape means it ports with no edit at all.
 *
 * `row` is a separate input rather than part of an object literal so
 * ngOnChanges fires when the row actually changes, not on every
 * change-detection pass for every row on the page.
 */
@Directive({ selector: '[appGridRowHook]', standalone: false })
export class GridRowHookDirective implements OnChanges {
  @Input('appGridRowHook') handler?: (e: any) => void;
  @Input() rowHookData: any;

  constructor(private el: ElementRef<HTMLElement>) { }

  ngOnChanges(): void {
    if (typeof this.handler !== 'function') { return; }
    this.handler({
      rowType: 'data',
      data: this.rowHookData,
      rowElement: this.el.nativeElement,
    });
  }
}
